<nx-file-upload-name [name]="data.file.name"> </nx-file-upload-name>
